import { fabric } from 'fabric';
import debounce from 'lodash-es/debounce';
import set from 'lodash-es/set';
import Papa from 'papaparse';
import bb, {
  area,
  bar,
  bubble,
  donut,
  gauge,
  line,
  pie,
  radar,
  scatter,
  step,
} from 'billboard.js';

import 'billboard.js/dist/billboard.css';
import './LudusChart.css';
import numeral from 'numeral';

const canvasEventProxy = (listener, _this) => o => {
  if (_this.canvas) {
    listener.call(_this, o);
  }
};

const LudusChart = fabric.util.createClass(fabric.Group, {
  type: 'ludusChart',
  showLegend: true,
  showAxis: true,

  initialize(image, options = {}) {
    options.width = options.width || 900;
    options.height = options.height || 576;
    if (image || options.objects) {
      this.imageSrc = image ? image.src : options.objects[0].src;
      this.imageObject = new fabric.ImageAsync(image || options.objects[0], {
        originY: 'center',
        originX: 'center',
        width: options.width,
        height: options.height,
      });
      set(options, 'ludus.chartConfig.axis.x.show', options.showAxis);
      set(options, 'ludus.chartConfig.axis.y.show', options.showAxis);
      set(options, 'ludus.chartConfig.legend.show', options.showLegend);
      this.callSuper(
        'initialize',
        [this.imageObject],
        { ...options, originX: 'center', originY: 'center' },
        true,
      );
    } else {
      this.imageObject = new fabric.ImageAsync(
        options.src,
        { ...options, left: 0, top: 0 },
        null,
        LudusChart.initImage,
      );

      this.callSuper(
        'initialize',
        [this.imageObject],
        {
          ...options,
          originX: 'center',
          originY: 'center',
        },
        true,
      );
    }

    this.on('mousedblclick', this.edit.bind(this));
    this.on('scaling', this.handleScaling.bind(this));
    this.on('scaled', this.handleScaled.bind(this));
    this.on('modified', this.handleModified.bind(this));
    this.canvasObjectScaledHandler = canvasEventProxy(
      this.onCanvasObjectScaled,
      this,
    );
  },

  _set(key, value) {
    if (!this.canvas) {
      this.callSuper('_set', key, value);
      if (key === 'canvas') {
        this.addCanvasListeners();
        // this._generateChart();
      }

      return this;
    }
    if (key === 'chartType') {
      this.callSuper('_set', key, value);
      this.canvas.fire('object:modified', { target: this });
      this._generateChart();

      return this;
    }
    if (key === 'showLegend') {
      set(this, 'ludus.chartConfig.legend.show', value);
      this.callSuper('_set', key, value);
      this.canvas.fire('object:modified', { target: this });
      this._generateChart();

      return this;
    }

    if (key === 'showAxis') {
      set(this, 'ludus.chartConfig.axis.y.show', value);
      set(this, 'ludus.chartConfig.axis.x.show', value);
      this.callSuper('_set', key, value);
      this.canvas.fire('object:modified', { target: this });
      this._generateChart();

      return this;
    }

    if (key === 'canvas') {
      if (value) {
        // Canvas is set, we can use it
        this.addCanvasListeners();
        this._generateChart();
      }
    }

    if (key === 'width' || key === 'height') {
      // this._shouldRender = false;
      this.imageObject.rendered = false;
      this.imageObject.loaded = false;
      this.callSuper('_set', key, value);
      this._generateChart();
      return this;
    }

    this.callSuper('_set', key, value);
    return this;
  },

  addCanvasListeners() {
    if (!this.canvas) {
      return;
    }
    // Be sure to remove all existing listeners before adding new ones
    this.canvas.on('object:scaled', this.canvasObjectScaledHandler);
  },
  removeCanvasListeners() {
    if (!this.canvas) {
      return;
    }
    this.canvas.off('object:scaled', this.canvasObjectScaledHandler);
  },
  onCanvasObjectScaled(o) {
    if (fabric.util.treeContainsObject(o.target, this)) {
      this._generateChart();
    }
  },

  dispose() {
    this.removeCanvasListeners();
  },

  handleScaled() {
    this._generateChart();
  },
  handleScaling() {
    this.imageObject.rendered = false;
    this.imageObject.loaded = false;
    // this._shouldRender = false;
  },

  handleModified(event) {
    if (event.by) {
      this._generateChart();
    }
  },

  toObject(propertiesToInclude = []) {
    const extraProps = ['chartDataTxt', 'chartType', 'showLegend', 'showAxis'];
    const object = this.callSuper(
      'toObject',
      propertiesToInclude.concat(extraProps),
    );
    return { ...object, objects: null };
  },

  render(ctx) {
    if (
      !this.canvas._currentTransform ||
      this.canvas._currentTransform.target !== this ||
      this.canvas._currentTransform.action === 'drag' ||
      this.canvas._currentTransform.action === 'rotate'
    ) {
      this.callSuper('render', ctx);
    } else {
      ctx.save();
      ctx.fillStyle = 'rgba(0, 0, 0, 0.15)';
      const width = this.width;
      const height = this.height;
      this.transform(ctx);
      ctx.fillRect(-(width / 2), -(height / 2), width, height);
      ctx.restore();
    }
  },

  edit() {
    LudusChart.editionCallback();
  },

  updateDataAndImage(chartConfig, chartDataTxt, chartType, imageUrl, callback) {
    fabric.util.loadImage(
      imageUrl,
      image => {
        if (image) {
          this.imageSrc = image.src;
          const newImageObject = new fabric.ImageAsync(image, {
            originY: 'center',
            originX: 'center',
            width: this.width,
            height: this.height,
          });

          this.remove(this.imageObject);
          this.add(newImageObject);
          this.imageObject = newImageObject;
          this.chartDataTxt = chartDataTxt;
          this.chartType = chartType;
          this.ludus = {
            ...this.ludus,
            ...chartConfig,
          };
          if (callback) {
            callback(this); // eslint-disable-line standard/no-callback-literal
          }
        }
      },
      null,
      'Anonymous',
    );
  },
  _generateChart(domElement = null, callback) {
    if (!this._debouncedGenerateChart) {
      this._debouncedGenerateChart = debounce(
        () => {
          const {
            chartType,
            valueData,
            chartColors,
          } = fabric.LudusChart.transformData(
            this.chartDataTxt,
            this.chartType,
          );
          fabric.LudusChart.generateChart(
            valueData,
            chartType,
            {
              width: this.width,
              height: this.height,
            },
            chartColors,
            domElement,
            this.ludus.chartConfig,
            true,
            this,
          ).then(chart => {
            chart.export(null, data => {
              this.updateDataAndImage(
                null,
                this.chartDataTxt,
                this.chartType,
                data,
                callback,
              );
            });
          });
        },
        100,
        { leading: false, trailing: true },
      );
    }

    this._debouncedGenerateChart();
  },
});

LudusChart.fromObject = (object, callback) => {
  const options = fabric.util.object.clone(object, true);
  let imageSrc;
  if (options.objects) {
    imageSrc = options.objects[0].src;
  } else {
    imageSrc = options.imageSrc;
    delete options.imageSrc;
  }
  callback && callback(new LudusChart(imageSrc, options));
};

LudusChart.registerEditionCallback = callback => {
  LudusChart.editionCallback = callback;
};

LudusChart.registerModifyCallback = callback => {
  LudusChart.handleModifiedCallback = callback;
};

LudusChart.transformDataConfigLine = valueDataTxt => {
  const configs = [];
  let firstLineConfigStartCell = null;
  let firstLineConfigEndCell = null;

  let newValueDataTxt = valueDataTxt;
  const endOfFirstLine = valueDataTxt.indexOf('\n');
  const firstLineStr = valueDataTxt.substring(0, endOfFirstLine);
  const firstLineArr = firstLineStr
    .replace(' ,', ',')
    .replace(', ', ',')
    .split(',');

  firstLineArr.map((cell, index) => {
    firstLineConfigStartCell = /^{{(.*?)/g.test(cell)
      ? index
      : firstLineConfigStartCell;
    firstLineConfigEndCell = /(.*?)}}$/g.test(cell)
      ? index
      : firstLineConfigEndCell;
  });

  if (firstLineConfigStartCell !== null && firstLineConfigEndCell !== null) {
    firstLineArr.map(cell => {
      const configItem = cell
        .replace('{{ ', '')
        .replace(' }}', '')
        .replace('{{', '')
        .replace('}}', '');
      configs.push(configItem);
    });

    newValueDataTxt = valueDataTxt.substring(endOfFirstLine + 1);
  }

  return {
    valueDataTxt: newValueDataTxt,
    configs,
  };
};

LudusChart.getLabelConfig = label => {
  const labelConfig = /{{(.*?)}}/g.exec(label);
  let newLabel = label;
  let color = null;

  if (labelConfig) {
    newLabel = label.replace(labelConfig[0], '');

    if (/^#([0-9a-f]{6}|[0-9a-f]{3})$/i.test(labelConfig[1].trim())) {
      color = labelConfig[1];
    } else {
      color = {
        error: `${
          labelConfig[1]
        } does not match a color code for label "${newLabel.trim()}"`,
      };
    }
  }

  return {
    color: color,
    label: newLabel.trim(),
  };
};

LudusChart.charts = {
  area,
  bar,
  bubble,
  donut,
  gauge,
  line,
  pie,
  radar,
  scatter,
  step,
};

LudusChart.transformData = (valueDataTxt, chartTypeSelect) => {
  const chartColors = {};
  let chartType =
    LudusChart.charts[chartTypeSelect.value || chartTypeSelect] || bar;
  let valueData = [];
  const dataErrors = [];

  const removeSpaces = (str, index, identifier) => {
    try {
      return str
        .replace(' -', '-')
        .replace('- ', '-')
        .replace(' :', ':')
        .replace(': ', ':')
        .replace(' ,', ',')
        .replace(', ', ',');
    } catch (error) {
      let lineError = '';
      if (index) {
        lineError = ` (line: ${index})`;
      }
      dataErrors.push(`Invalid data format${lineError}`);
      return '';
    }
  };

  const transformedData = LudusChart.transformDataConfigLine(valueDataTxt);
  const newValueDataTxt = transformedData.valueDataTxt;
  const configs = transformedData.configs;
  let inputTypeData = null;

  configs.map(item => {
    if (LudusChart.charts[item]) {
      chartType = LudusChart.charts[item];
    } else {
      dataErrors.push('Invalid chart type');
    }
  });

  let dataToChart = null;
  let valueArray = null;

  if (!chartTypeSelect) {
    chartType = configs[0];
  }

  try {
    valueArray = newValueDataTxt
      .split('\n')
      .map((line, index) => {
        if (/^-/g.test(line) && /:/g.test(line)) {
          inputTypeData = 'md';
          return removeSpaces(line, index, 'code 1')
            .split(':')
            .map((value, index) => {
              if (index > 0) {
                return value.split(',').map(value => {
                  if (isNaN(Number(value))) {
                    dataErrors.push(
                      `Not a numeric value: ${value} (line: ${index})`,
                    );
                  }
                  return isNaN(Number(value))
                    ? value.replace(' ', '')
                    : Number(value);
                });
              } else {
                const labelConfig = LudusChart.getLabelConfig(
                  removeSpaces(value, index, 'code 2').replace('-', ''),
                );
                if (labelConfig.color && labelConfig.color.error) {
                  dataErrors.push(labelConfig.color.error);
                } else {
                  chartColors[labelConfig.label] =
                    labelConfig.color || undefined;
                }
                return labelConfig.label;
              }
            });
        }
      })
      .filter(line => !!line);
  } catch (error) {
    dataErrors.push('Invalid data format');
    return {
      errors: dataErrors,
    };
  }

  if (inputTypeData === 'md') {
    valueData = valueArray.map(line => line.flat());
  } else {
    const csvParsed = Papa.parse(newValueDataTxt, {
      delimitersToGuess: ['\t', ',', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP],
      skipEmptyLines: true,
    });

    csvParsed.data.forEach((line, lineIndex) => {
      line.forEach((o, index) => {
        if (lineIndex > 0) {
          const myNumeral = numeral(o);
          const value = myNumeral.value();

          if (value) {
            csvParsed.data[lineIndex][index] = value;
          }
        }
      });
    });

    if (csvParsed.errors.length === 0) {
      dataToChart = csvParsed.data;
      valueData = dataToChart[0].map((item, i) => {
        const columnData = [removeSpaces(item, null, 'code 3').trim()];
        const labelConfig = LudusChart.getLabelConfig(columnData[0]);
        columnData[0] = removeSpaces(labelConfig.label);

        if (labelConfig.color && labelConfig.color.error) {
          dataErrors.push(labelConfig.color.error);
        } else {
          chartColors[labelConfig.label] = labelConfig.color || undefined;
        }
        for (let j = 1; j < dataToChart.length; j++) {
          const strValue = dataToChart[j][i]; // removeSpaces(dataToChart[j][i], j, 'code 4').trim();
          if (isNaN(Number(strValue))) {
            dataErrors.push(`Not a numeric value: ${strValue} (line: ${j})`);
          } else {
            columnData.push(strValue);
          }
        }
        return columnData;
      });

      return {
        chartType,
        valueData,
        chartColors,
        errors: dataErrors,
      };
    } else {
      dataErrors.push('Invalid csv format');
    }
  }

  return {
    chartType,
    valueData,
    chartColors,
    errors: dataErrors,
  };
};

LudusChart.generateChart = (
  valueData,
  type = bar,
  size = { width: 900, height: 576 },
  chartColors,
  domElement,
  chartConfig,
) => {
  const chartElementWrapper = document.createElement('div');
  const chartElement = document.createElement('div');

  const formatType = type.value ? LudusChart.charts[type.value]() : type();
  chartElementWrapper.style.width = `${size.width}px`;
  chartElementWrapper.style.height = `${size.height}px`;
  chartElementWrapper.appendChild(chartElement);

  chartElementWrapper.style.position = 'absolute';
  chartElementWrapper.style.top = `-${size.height + 1000}px`;
  chartElementWrapper.style.left = `-${size.width + 1000}px`;

  document.body.appendChild(chartElementWrapper);

  return new Promise(resolve => {
    const chart = bb.generate({
      data: {
        type: formatType,
        columns: valueData,
        colors: chartColors,
      },
      size: {
        width: size.width,
        height: size.height,
      },
      // -- legend: { show: false },
      ...chartConfig,
      bindto: chartElement,
      onafterinit: () => {
        setTimeout(() => {
          chart.export(null, data => {
            if (domElement) {
              chartElementWrapper.style.top = `0px`;
              chartElementWrapper.style.left = `0px`;
              domElement.appendChild(chartElementWrapper);
            } else {
              chartElementWrapper.remove();
            }
            chart.svgDataUrl = data;
            resolve(chart, chartElementWrapper);
          });
        }, 0);
      },
      transition: {
        duration: 0,
      },
    });
  });
};

LudusChart.initImage = (options, callback) => {
  const chartDataTxt = options.chartDataTxt;
  const chartTypeSelect = options.chartType;
  const { chartType, valueData, chartColors } = fabric.LudusChart.transformData(
    chartDataTxt,
    chartTypeSelect.value,
  );
  fabric.LudusChart.generateChart(
    valueData,
    chartType,
    {
      width: options.width,
      height: options.height,
    },
    chartColors,
    null,
    options.ludus.chartConfig,
  ).then(chart => {
    chart.export(null, data => {
      fabric.util.loadImage(data, callback, null, 'Anonymous');
    });
  });
};

export default LudusChart;
